import * as z from "zod";

export const getChargebacksProviderStatus = {
  name: "getChargebacksProviderStatus" as const,
  input: z.object({}),
  output: z.object({
    shopify: z.object({ connected: z.boolean() }),
    paypal: z.object({ connected: z.boolean() }),
    stripe: z.object({ connected: z.boolean() }),
    gorgias: z.object({ connected: z.boolean() }),
  }),
};
